import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginModel } from 'src/app/models/login.model';


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent implements OnInit {


  currentRouter = this.router.url;

  anio: number;

  login: LoginModel;

  recordarme = false;

  error: boolean;
  msjError: string;

  constructor(private auth: AuthService, private router: Router, private activatedRoute: ActivatedRoute) {
    this.anio = new Date().getFullYear();

 }

  ngOnInit(): void {

    this.login = new LoginModel();

    if (localStorage.getItem('nombrelogin')) {
      this.login.nombrelogin = localStorage.getItem('nombrelogin');
      this.recordarme = true;
    }

  }

  OnLogin(form: NgForm){

    if (form.invalid) { return; }

    this.auth.logIn(this.login)
    .subscribe(resp => {
      if (this.recordarme) {
        localStorage.setItem('nombrelogin', this.login.nombrelogin);
      }
        //   this.router.navigate(['inicio']);
        //  window.location.reload();
        this.router.navigate(['/admin/principal']);
    }
    , (errorService) => {
      this.error = true;
      this.msjError = errorService.error;
      setTimeout( ()=>{      
        this.error = false
    }, 2000); 

    
    });


  }

}
